import { useSelector } from 'react-redux';

import { useIsActiveLoyalty } from 'checkout/loyalty/utils/hooks';
import { useLocalization } from 'redux/localization/utils/hooks';

import { currencyFormat } from '../../../helpers/numberHelper';

const LoyaltyPoints = (props) => {
  const { cartOrOrder } = props;
  const { t } = useLocalization();
  const isLoyaltyActive = useIsActiveLoyalty();
  const setting = useSelector((state) => state.setting.data);

  if (!isLoyaltyActive) return null;

  const loyaltyTender = cartOrOrder.tenders.find(
    (tender) => tender.tenderType === 'Loyalty Points'
  );

  if (!loyaltyTender) return null;

  return (
    <div className="c7-order-summary__item--notes">
      <div className="c7-order-summary__title">
        {t('checkout.general.paidByPoints')}
      </div>
      <div className="c7-order-summary__value">
        -{currencyFormat(loyaltyTender.amountTendered, setting.currency)}
      </div>
    </div>
  );
};

export default LoyaltyPoints;
